<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="formulario ? formulario.title : ''"
        centered
        size="xl"
        @hidden="cancelar"
        id="modal-formulario"
    >
        <load v-if="loading" :message="message" mode="table" />
        <div v-else>
            <form-input-master
                v-for="(item, index) in itens"
                :key="index"
                :index="index"
                :type="FormatType(item.type)"
                :title="item.title"
                :text="item.text"
                :label="item.label"
                :itens="formatItens(item.values)"
                :value="respostas[index]"
                @input="setValue"
            />
            <div class="row mt-3">
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-success" @click="save">
                        <i class="mdi mdi-check-circle"></i> Concluir
                    </button>
                    <button class="btn btn-default" @click="cancelar">
                        <i class="mdi mdi-close"></i> Responder depois
                    </button>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: "ModalFormulario",
    data() {
        return {
            loading: true,
            message: "Carregando",
            formulario: [],
            itens: [],
            respostas: [],
        };
    },

    mounted() {
        // this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
        //     this.verificar();
        // });
        this.getFormulario();
    },
    methods: {
        setValue(item, index) {
            //console.log(item);
            //console.log(index);
            this.itens[index].value = item;
        },
        getFormulario() {
            this.loading = true;
            axios
                .get(`api/formulario`)
                .then((response) => {
                    this.formulario = response.data;
                    if (this.formulario.status == 1) {
                        this.itens = this.formulario.content;
                        this.$bvModal.show("modal-formulario");
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatItens(itens) {
            if (itens) {
                return itens.map((elem) => ({
                    id: elem.value,
                    value: elem.label,
                }));
            }
        },
        FormatType(type) {
            if (type == "textfield") {
                return "input";
            }
            return type;
        },

        save() {
            this.loading = true;
            this.message = "Salvando suas respostas...";
            axios
                .post(`api/formulario/save`, {
                    id: this.formulario.id,
                    content: this.itens,
                })
                .then((response) => {
                    swal.fire({
                        toast: true,
                        position: "top-end",
                        type: "success",
                        icon: "success",
                        title: "Obrigado por responder.",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    this.cancelar();
                });
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$root.load_change_unidade = false;
            this.$bvModal.hide("modal-formulario");
        },
    },
};
</script>
